import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { WalletUserExternalIdResponse } from '@/repositories/generated';

const response: WalletUserExternalIdResponse[] = [
  {
    externalId: 'external_wallet001',
  },
  {
    externalId: 'external_wallet002',
  },
  {
    externalId: 'external_wallet003',
  },
];

export const autocompleteExternalWalletUserId = http.get(
  createMockEndpoint('/autocomplete/wallet_user/externalId'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
